/**
 * Series-source predicate — leaf module (pure, zero deps) so both
 * `getAvailableSeries` and `indicatorDisplayName` can import it without forming an
 * import cycle. Extracted from getAvailableSeries.js (behavior unchanged).
 *
 * @module seriesSource
 */

/**
 * Check if a source path is a series reference (not OHLC)
 * @param {string} sourcePath - Source path to check
 * @returns {boolean} True if series reference
 *
 * @example
 * isSeriesSource('close') // false
 * isSeriesSource('rsi_14.rsi') // true
 */
export function isSeriesSource(sourcePath) {
  if (!sourcePath || typeof sourcePath !== "string") {
    return false;
  }

  // Check if it's a known OHLC field
  const ohlcFields = [
    "open",
    "high",
    "low",
    "close",
    "hl2",
    "hlc3",
    "ohlc4",
    "hlcc4",
  ];
  const normalized = sourcePath.toLowerCase().trim();

  if (ohlcFields.includes(normalized)) {
    return false;
  }

  // Series sources use dot notation
  return sourcePath.includes(".");
}
